/**
 * TikTok videos section
 * - Mute/unmute per card (muted by default; only one unmuted at a time)
 * - Autoplay when in view, pause when out of view
 * - ADD opens Quickshop via ProductThumbnail (same as product cards)
 *
 * Note: ProductThumbnail requires [data-rimg] inside [data-product-thumbnail]
 * or it returns early and never binds ProductQuickshop.
 */
(function () {
  'use strict';

  function setMuteUI(button, muted) {
    if (!button) return;
    button.setAttribute('aria-pressed', muted ? 'true' : 'false');
    button.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
    var mutedIcon = button.querySelector('.tiktok-videos__mute-icon--muted');
    var unmutedIcon = button.querySelector('.tiktok-videos__mute-icon--unmuted');
    if (mutedIcon) {
      mutedIcon.hidden = !muted;
      mutedIcon.classList.toggle('is-hidden', !muted);
    }
    if (unmutedIcon) {
      unmutedIcon.hidden = muted;
      unmutedIcon.classList.toggle('is-hidden', muted);
    }
  }

  function muteOthers(section, exceptVideo) {
    section.querySelectorAll('[data-tiktok-video]').forEach(function (video) {
      if (video === exceptVideo) return;
      video.muted = true;
      video.dataset.userUnmuted = 'false';
      var card = video.closest('[data-tiktok-card]');
      if (!card) return;
      setMuteUI(card.querySelector('[data-tiktok-mute]'), true);
    });
  }

  function bindMute(card, section) {
    var video = card.querySelector('[data-tiktok-video]');
    var muteBtn = card.querySelector('[data-tiktok-mute]');
    if (!video || !muteBtn || muteBtn.dataset.bound === 'true') return;

    muteBtn.dataset.bound = 'true';
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    setMuteUI(muteBtn, true);

    muteBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var nextMuted = !video.muted;
      if (!nextMuted) muteOthers(section, video);
      video.muted = nextMuted;
      video.dataset.userUnmuted = nextMuted ? 'false' : 'true';
      setMuteUI(muteBtn, nextMuted);
      if (!nextMuted) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    });
  }

  function observeVideos(section) {
    var videos = section.querySelectorAll('[data-tiktok-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        video.muted = true;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
            if (video.dataset.userUnmuted !== 'true') {
              video.muted = true;
            }
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      },
      { threshold: [0, 0.4, 0.75] }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  function bindProductThumbnails(section) {
    if (!window.PXUTheme || typeof window.PXUTheme.ProductThumbnail !== 'function') {
      return false;
    }

    section.querySelectorAll('[data-product-thumbnail]').forEach(function (node) {
      if (node.dataset.tiktokThumbnailBound === 'true') return;
      if (!node.querySelector('[data-rimg]')) return;
      if (!node.querySelector('[data-quickshop-button]')) return;

      node.dataset.tiktokThumbnailBound = 'true';
      new window.PXUTheme.ProductThumbnail(node, {
        showSecondaryMediaOnHover: false
      });
    });

    return true;
  }

  function initSection(section) {
    if (!section) return;

    section.querySelectorAll('[data-tiktok-card]').forEach(function (card) {
      bindMute(card, section);
    });

    if (!section.dataset.tiktokObserverReady) {
      section.dataset.tiktokObserverReady = 'true';
      observeVideos(section);
    }

    if (!bindProductThumbnails(section)) {
      window.setTimeout(function () {
        bindProductThumbnails(section);
      }, 600);
      window.setTimeout(function () {
        bindProductThumbnails(section);
      }, 1600);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-tiktok-videos]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // retina.min.js is deferred — retry after load
  window.addEventListener('load', function () {
    window.setTimeout(initAll, 100);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root) return;
    var section =
      root.querySelector('[data-tiktok-videos]') ||
      (root.matches && root.matches('[data-tiktok-videos]') ? root : null);
    if (section) {
      section.dataset.tiktokObserverReady = '';
      section.querySelectorAll('[data-product-thumbnail]').forEach(function (node) {
        node.dataset.tiktokThumbnailBound = '';
      });
      initSection(section);
    }
  });
})();
